import BaseSlider from '../../common/components/sliders/components/BaseSlider';
import Insurance from '../assets/icon/insurance.svg';
import fee from '../assets/icon/no-fee.svg';
import megaphone from '../assets/icon/megaphone.svg';
export function InfoSlider() {
  const breakpoints = {
    desktop: {
      breakpoint: { max: 10000, min: 1200 },
      items: 3,
      slidesToSlide: 2,
      partialVisibilityGutter: 30,
    },
    tablet: {
      breakpoint: { max: 1200, min: 670 },
      items: 2,
      slidesToSlide: 2,
      partialVisibilityGutter: 40,
    },
    mobile: {
      breakpoint: { max: 670, min: 300 },
      items: 1,
      slidesToSlide: 1,
      partialVisibilityGutter: 35,
    },
    smallMobile: {
      breakpoint: { max: 300, min: 0 },
      items: 1,
      slidesToSlide: 1,
      partialVisibilityGutter: 0,
    },
  };

  return (
    <BaseSlider
      horizontal
      infinite={false}
      hideButtons
      className='info-slider mg-bottom-50'
      breakpointsOverride={breakpoints}
      showPartialNext
      extra=''
      noHoverAnimation
    >
      <div className='bg-white br30 pd-20 '>
        <img src={fee} alt='no fee Logo' className='mg-bottom-10' />
        <div className='fs-20 mg-bottom-10 gSemiBold grey-900'>
          FREE to use for anglers
        </div>
        <div className='fs-16 gRegular grey-900'>
          Our ethos has always been to maintain a free to use platform for
          anglers. This encourages users to adopt a new system and removes
          barriers to adopting tech.
        </div>
      </div>
      <div className='bg-white br30 pd-20 '>
        <img src={Insurance} alt='user Logo' className='mg-bottom-10' />
        <div className='fs-20 mg-bottom-10 gSemiBold grey-900'>
          Solid & Reliable System
        </div>
        <div className='fs-16 gRegular grey-900'>
          The angling industry has been slow to adopt tech alongside other
          leisure sports. With our extensive knowledge in technology, we’ve
          listened to fisheries across the country to build our easy to use,
          reliable booking system.
        </div>
      </div>
      <div className='bg-white br30 pd-20 '>
        <img src={megaphone} alt='phone Logo' className='mg-bottom-10' />
        <div className='fs-20 mg-bottom-10 gSemiBold grey-900'>
          Extensive Marketing Support
        </div>
        <div className='fs-16 gRegular grey-900'>
          Our in-house media team has all the skills to capture your venue in
          the perfect light. From our{' '}
          <span
            className='txt-underline sb-blue cp gSemiBold'
            onClick={() =>
              window.open(
                'https://www.youtube.com/watch?v=u9B4BsDwRbA&ab_channel=Swimbooker',
                '_blank'
              )
            }
          >
            FPV Drone Flythrough
          </span>{' '}
          to our industry first{' '}
          <span
            className='txt-underline sb-blue cp gSemiBold'
            onClick={() =>
              window.open(
                'https://tours.swimbooker.com/tours/wP3DZdfva',
                '_blank'
              )
            }
          >
            360 Degree Virtual Experience
          </span>
          , all swimbooker lakes benefit from our marketing experience.
        </div>
      </div>
    </BaseSlider>
  );
}
